import { useCallback } from 'react';
import { QueueController } from '../transport/QueueController';

export function useLocalCatalogSearchHandlers(nav, onClose) {
  const handleSelectLocalArtist = useCallback((artist) => {
    onClose();
    nav.openArtist({ id: artist.id, name: artist.name, __source: 'local_library' });
  }, [nav, onClose]);

  const handleSelectLocalAlbum = useCallback((album) => {
    onClose();
    nav.openAlbum({
      id: album.id,
      album_key: album.album_key || album.id,
      title: album.title,
      artist_name: album.artistName,
      __source: 'local_library',
      source: 'local_library',
    });
  }, [nav, onClose]);

  const handleSelectLocalTrack = useCallback((track) => {
    onClose();
    QueueController.playAll([{
      id: track.id || `local_search_${Date.now()}`,
      title: track.title || 'Unknown',
      artist: track.artist || track.artistName || '',
      album: track.album || '',
      artworkUrl: track.artworkUrl || '',
      duration: track.duration || 0,
      source: 'local_library',
      format: String(track.format || '').toUpperCase() || 'FLAC',
      file_path: track.file_path,
      machine_id: track.machine_id,
    }]);
  }, [onClose]);

  return { handleSelectLocalArtist, handleSelectLocalAlbum, handleSelectLocalTrack };
}
